<template>
    <el-dialog
        :before-close="cancel"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        append-to-body
        center
        width="60%">
        <div class="content flex flex-direction">
            <div class="text-xxl text-bold text-black self-center">{{ detail.title }}</div>
            <div class="text-df text-black self-center margin-top-sm">发布时间：{{ detail.create_time }}</div>
            <div class="margin-top-sm detail" v-html="detail.content"></div>
        </div>
    </el-dialog>
</template>

<script>


import {backActiveDetail} from "@/api";

export default {
    name: "FlowDetailDialog",
    components: {},
    data() {
        return {
            detail: ''
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        aid: {
            type: Number,
            default: 0
        },
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    created() {
        if (this.aid) this.init()
    },
    methods: {
        async init() {
            let _data = await backActiveDetail(this.aid)
            this.detail = _data.data
        },
        cancel() {
            this.$emit('watchState', false)
        },
    },
    filters: {},
    watch: {
        aid() {
            if (this.aid) this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    height: 60vh;
    overflow: auto;
}
</style>